

        <div *ngIf="!loading" class="qbodyText" >{{myCount+1}}.

              <a *ngIf="!isGrouping"
              [routerLink]="['/student/quiz/do',learner.server_user_id,quizEnvelop.server_quiz_envelop_id,question.server_question_id,question.questionIndex]">
                <span [innerHTML]="question.questionText"></span>
              </a>

              <span *ngIf="isGrouping">
                <span [innerHTML]="question.questionText"></span>
              </span>


        </div>
        <app-show-question-prompt *ngIf="question.prompts.length>0" [prompts]="question.prompts"></app-show-question-prompt>

       <div id="myquestion_{{question.server_question_id}}" *ngIf="loading"></div>
